export default "__VITE_ASSET__BZm$7CXQ__"